import script from "./MessageItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageItem.vue?vue&type=script&setup=true&lang=js"

import "./MessageItem.vue?vue&type=style&index=0&id=56f549f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56f549f4"]])

export default __exports__